import axios from "axios";
import { Auth_Proto, Auth_Domain, Auth_Port } from "../Component/consts";

const api = axios.create({
    baseURL: `${Auth_Proto}${Auth_Domain}${Auth_Port}/api/masters`,
});

export const reportApi = {
    payments: (filters = {}) => api.get("/reports/payments", { params: filters }),
    refunds: (filters = {}) => api.get("/reports/refunds", { params: filters }),
    subscriptions: (filters = {}) =>
        api.get("/reports/subscriptions", { params: filters }),
    revenue: (filters = {}) => api.get("/reports/revenue", { params: filters }),
    gateways: (filters = {}) => api.get("/reports/gateway", { params: filters }),
};